import { Pipe, PipeTransform, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';


@Pipe({ name: 'meta' })
export class MetaPipe implements PipeTransform {
    transform(item: any): any {
        return item && item.hasOwnProperty("meta") ? item.meta : item;
    }
}

/// PropPipe: returns the value of an item property
// @Pipe({ name: 'prop' })
// export class PropPipe implements PipeTransform {
//     transform(item: any, property: string): any {
//         return item.hasOwnProperty(property) ? item[property] : null;
//     }
// }

@Pipe({ name: 'url' })
export class UrlPipe implements PipeTransform {
    transform(item: any): any {
        return item && item.hasOwnProperty("url") ? item.url : null;
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/meta.pipe.ts